import React from "react"
import {connect} from "react-redux"
import {Transition} from "react-transition-group"

import "./hourglass.scss"

/**
 * Preloader
 * @component
 * @param  {object} props
 * @param  {function} props.hourglassState - component state
 * @param  {string} props.active - component state
 *
 * @example
 * return (
 *  <Hourglass />
 * )
 */

const Hourglass = ({hourglassState, active}) => {
  const handleClick = e => {
    e.preventDefault()
    e.stopPropagation()
  }

  return (
    <Transition
      in={hourglassState || active}
      timeout={200}
      unmountOnExit={true}
    >
      {state => (
        <div
          className="hourglassContainer"
          style={{...transitionStyles}}
          onClick={handleClick}
        >
          <div className="hourglassContainer_item">
            <img src="/assets/img/icons/hourglass.svg" alt="hourglass" />
          </div>
        </div>
      )}
    </Transition>
  )
}

const mapStateToProps = ({hourglassState}) => ({hourglassState})

export default connect(mapStateToProps)(Hourglass)

const transitionStyles = {
  entering: {opacity: 0},
  entered: {opacity: 1},
  exiting: {opacity: 0},
  exited: {opacity: 0},
}
